/* Cartera de isotipos: seis círculos en rejilla. [columna, fila] en orden de color.
 * El color i-ésimo es siempre fct.isotipo[i+1]. Generado desde 02 Marca. No editar a mano. */
export const ISOTIPOS = {
  'gescom': [[0, 0], [1, 0], [2, 0], [0, 1], [1, 1], [2, 1]],
  '1x6-01': [[0, 0], [1, 0], [2, 0], [3, 0], [4, 0], [5, 0]],
  '2x4-01': [[0, 0], [1, 0], [2, 0], [3, 0], [0, 1], [1, 1]],
  '2x4-02': [[0, 0], [1, 0], [2, 0], [3, 0], [0, 1], [2, 1]],
  '2x4-03': [[0, 0], [1, 0], [2, 0], [0, 1], [2, 1], [3, 1]],
  '2x4-04': [[0, 0], [1, 0], [2, 0], [3, 0], [0, 1], [3, 1]],
  '2x4-05': [[0, 0], [1, 0], [2, 0], [3, 0], [1, 1], [2, 1]],
  '2x4-06': [[0, 0], [1, 0], [2, 0], [1, 1], [2, 1], [3, 1]],
  '2x5-01': [[0, 0], [1, 0], [2, 0], [3, 0], [4, 0], [0, 1]],
  '2x5-02': [[0, 0], [1, 0], [2, 0], [3, 0], [4, 0], [1, 1]],
  '2x5-03': [[0, 0], [1, 0], [1, 1], [2, 1], [3, 1], [4, 1]],
  '2x5-04': [[0, 0], [1, 0], [2, 0], [3, 0], [4, 0], [2, 1]],
  '2x5-05': [[0, 0], [1, 0], [2, 0], [2, 1], [3, 1], [4, 1]],
  '3x3-01': [[0, 0], [1, 0], [2, 0], [0, 1], [1, 1], [0, 2]],
  '3x3-02': [[0, 0], [1, 0], [0, 1], [1, 1], [2, 1], [0, 2]],
  '3x3-03': [[0, 0], [1, 0], [2, 0], [0, 1], [0, 2], [1, 2]],
  '3x3-04': [[0, 0], [2, 0], [0, 1], [1, 1], [2, 1], [0, 2]],
  '3x3-05': [[0, 0], [1, 0], [0, 1], [1, 1], [2, 1], [1, 2]],
  '3x3-06': [[0, 0], [1, 0], [0, 1], [1, 1], [1, 2], [2, 2]],
  '3x3-07': [[0, 0], [2, 0], [0, 1], [1, 1], [2, 1], [1, 2]],
  '3x4-01': [[0, 0], [1, 0], [2, 0], [3, 0], [0, 1], [0, 2]],
  '3x4-02': [[0, 0], [0, 1], [1, 1], [2, 1], [3, 1], [0, 2]],
  '3x4-03': [[0, 0], [0, 1], [1, 1], [2, 1], [3, 1], [1, 2]],
  '3x4-04': [[0, 0], [0, 1], [1, 1], [1, 2], [2, 2], [3, 2]],
  '3x4-05': [[0, 0], [0, 1], [1, 1], [2, 1], [3, 1], [2, 2]],
  '3x4-06': [[0, 0], [0, 1], [1, 1], [2, 1], [2, 2], [3, 2]],
  '3x4-07': [[0, 0], [0, 1], [1, 1], [2, 1], [3, 1], [3, 2]],
  '3x4-08': [[0, 0], [1, 0], [2, 0], [3, 0], [1, 1], [1, 2]],
  '3x4-09': [[0, 0], [1, 0], [1, 1], [2, 1], [3, 1], [1, 2]],
  '3x4-10': [[0, 0], [1, 0], [1, 1], [1, 2], [2, 2], [3, 2]],
  '3x4-11': [[0, 0], [1, 0], [1, 1], [2, 1], [3, 1], [2, 2]],
  '3x4-12': [[0, 0], [1, 0], [1, 1], [2, 1], [2, 2], [3, 2]],
  '3x4-13': [[0, 0], [1, 0], [2, 0], [2, 1], [3, 1], [2, 2]],
  '3x4-14': [[1, 0], [0, 1], [1, 1], [2, 1], [3, 1], [1, 2]],
  '3x4-15': [[1, 0], [0, 1], [1, 1], [2, 1], [3, 1], [2, 2]],
  'gdgo': [[0, 0], [0, 1], [0, 2], [1, 0], [1, 1], [1, 2]],
} as const;

export type FctForma = keyof typeof ISOTIPOS;

/** madre: Gescom y GdGO! · entorno: reservada, siempre en una tinta · libre: disponible · fuera: no es isotipo */
export const ESTADO_FORMA: Record<FctForma, 'madre' | 'entorno' | 'libre' | 'fuera'> = {
  'gescom': 'madre',
  '1x6-01': 'fuera',
  '2x4-01': 'libre',
  '2x4-02': 'libre',
  '2x4-03': 'libre',
  '2x4-04': 'libre',
  '2x4-05': 'libre',
  '2x4-06': 'entorno',
  '2x5-01': 'libre',
  '2x5-02': 'libre',
  '2x5-03': 'libre',
  '2x5-04': 'libre',
  '2x5-05': 'libre',
  '3x3-01': 'libre',
  '3x3-02': 'libre',
  '3x3-03': 'libre',
  '3x3-04': 'entorno',
  '3x3-05': 'libre',
  '3x3-06': 'libre',
  '3x3-07': 'libre',
  '3x4-01': 'libre',
  '3x4-02': 'libre',
  '3x4-03': 'libre',
  '3x4-04': 'libre',
  '3x4-05': 'libre',
  '3x4-06': 'libre',
  '3x4-07': 'libre',
  '3x4-08': 'libre',
  '3x4-09': 'libre',
  '3x4-10': 'libre',
  '3x4-11': 'libre',
  '3x4-12': 'libre',
  '3x4-13': 'libre',
  '3x4-14': 'libre',
  '3x4-15': 'libre',
  'gdgo': 'madre',
};

export const COLORES_ISOTIPO = ['#03C25B', '#81E1AD', '#B3EDCD', '#4F91FF', '#A6C6FF', '#D8E6FF'] as const;
